/**
 * @generated SignedSource<<ac8e4c33b1cb6935f6225f97bd86135b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetHistoryPeriod = "DAY" | "FIVE_YEARS" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type AssetByTypeViewQuery$variables = {
  assetHistoryPeriod?: AssetHistoryPeriod | null | undefined;
  id?: string | null | undefined;
};
export type AssetByTypeViewQuery$data = {
  readonly assetById: {
    readonly __typename: string;
    readonly distributionPolicy?: string | null | undefined;
    readonly dividendPerShare?: PrecisionFloat | null | undefined;
    readonly dividendPerShareYear?: number | null | undefined;
    readonly dividendYield?: number | null | undefined;
    readonly dividendYieldYear?: number | null | undefined;
    readonly fundSize?: number | null | undefined;
    readonly history: ReadonlyArray<{
      readonly __typename: "AssetHistory";
      readonly close: PrecisionFloat | null | undefined;
      readonly time: TimeScalar | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly isin?: string | null | undefined;
    readonly legalUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly peRatio?: number | null | undefined;
    readonly peRatioYear?: number | null | undefined;
    readonly portfolio?: {
      readonly assetBalance: PrecisionFloat | null | undefined;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assets: {
            readonly edges: ReadonlyArray<{
              readonly averageBuyPrice: PrecisionFloat | null | undefined;
              readonly fiatBalance: PrecisionFloat | null | undefined;
              readonly totalReturn: ValueChange | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly overallAmount: PrecisionFloat | null | undefined;
          readonly returnPercentage: number | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly totalInvested: PrecisionFloat | null | undefined;
      readonly totalReturn: ValueChange | null | undefined;
    } | null | undefined;
    readonly provider?: string | null | undefined;
    readonly recommendation?: {
      readonly breakdown: ReadonlyArray<{
        readonly percentage: number | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly replicationMethod?: string | null | undefined;
    readonly revenue?: PrecisionFloat | null | undefined;
    readonly revenueYear?: string | null | undefined;
    readonly totalExpenseRatio?: number | null | undefined;
    readonly yearlyNetIncomes?: ReadonlyArray<{
      readonly period: string | null | undefined;
      readonly value: PrecisionFloat | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AssetByTypeViewQuery = {
  response: AssetByTypeViewQuery$data;
  variables: AssetByTypeViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetHistoryPeriod"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isin",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fundSize",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "distributionPolicy",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "replicationMethod",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "provider",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalExpenseRatio",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalReturn",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "assetById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "legalUrl",
        "storageKey": null
      },
      (v2/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "period",
            "variableName": "assetHistoryPeriod"
          }
        ],
        "concreteType": "AssetHistory",
        "kind": "LinkedField",
        "name": "history",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "time",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "close",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dividendYield",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dividendPerShare",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dividendYieldYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dividendPerShareYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "peRatioYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "peRatio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenueYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetRecommendation",
            "kind": "LinkedField",
            "name": "recommendation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetRecommendationBreakdown",
                "kind": "LinkedField",
                "name": "breakdown",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "percentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HistoricalValue",
            "kind": "LinkedField",
            "name": "yearlyNetIncomes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "period",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "StockAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v3/*: any*/),
        "type": "EtfAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v3/*: any*/),
        "type": "EtcAsset",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetPortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalInvested",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetBalance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetPortfoliosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Portfolio",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "returnPercentage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "overallAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioAssetsConnection",
                        "kind": "LinkedField",
                        "name": "assets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PortfolioAssetsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "averageBuyPrice",
                                "storageKey": null
                              },
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fiatBalance",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "CryptoAsset",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetByTypeViewQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssetByTypeViewQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "138072b7dd96519f9013e44b4e667dcc",
    "id": null,
    "metadata": {},
    "name": "AssetByTypeViewQuery",
    "operationKind": "query",
    "text": "query AssetByTypeViewQuery(\n  $id: ID\n  $assetHistoryPeriod: AssetHistoryPeriod\n) {\n  assetById(id: $id) {\n    id\n    name\n    legalUrl\n    __typename\n    history(period: $assetHistoryPeriod) {\n      time\n      close\n      __typename\n    }\n    ... on StockAsset {\n      dividendYield\n      dividendPerShare\n      dividendYieldYear\n      dividendPerShareYear\n      peRatioYear\n      peRatio\n      revenue\n      revenueYear\n      recommendation {\n        totalCount\n        breakdown {\n          percentage\n          type\n        }\n      }\n      yearlyNetIncomes {\n        value\n        period\n      }\n    }\n    ... on EtfAsset {\n      isin\n      fundSize\n      distributionPolicy\n      replicationMethod\n      provider\n      totalExpenseRatio\n    }\n    ... on EtcAsset {\n      isin\n      fundSize\n      distributionPolicy\n      replicationMethod\n      provider\n      totalExpenseRatio\n    }\n    ... on CryptoAsset {\n      portfolio {\n        totalInvested\n        totalReturn\n        assetBalance\n        edges {\n          node {\n            returnPercentage\n            overallAmount\n            assets {\n              edges {\n                averageBuyPrice\n                totalReturn\n                fiatBalance\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bad566eb65847dbbe111e70d71584984";

export default node;
